/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Box, Divider, SimpleGrid, Switch, Text } from "@chakra-ui/react";
import { InputFormStyled, LabeFormlStyled } from "styled/Input.styled";
import { ButtonStyled } from "styled/Buttons.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useForm } from "hooks/useForm";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import useDebounceText from "hooks/useSearchDebounce";
import { useDebounceError } from "hooks/useDebounceError";
import { Regex } from "utils/Regex";

const validateForm = (form, openAlert) => {
  if (!form.email_custom.trim()) {
    openAlert("El campo email es obligatorio", "error");
    return false;
  }

  if (!form.name_custom.trim()) {
    openAlert("Ingrese el nombre de la aduana", "error");
    return false;
  }

  if (!form.code_custom.trim()) {
    openAlert("Ingrese el código de la aduana", "error");
    return false;
  }

  return true;
};

const CustomsForm = () => {
  const [openAlert] = AlertErrorAlert();

  const initialForm = {
    code_custom: "",
    name_custom: "",
    email_custom: "",
    description_custom: "",
    status_custom: 1
  };

  const { dataToEdit, onCloseModal, editData, createData } = useContext(
    ConfigurationCRUDContext
  );
  const [form, handleInputChange, resetForm, setForm] = useForm();
  const [check, setCheck] = useState(true);

  useEffect(() => {
    if (dataToEdit) {
      setForm({ ...dataToEdit });
      setCheck(dataToEdit.status_custom === 1);
    } else {
      setForm(initialForm);
    }
  }, [dataToEdit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm(form, openAlert)) return;

    if (dataToEdit) {
      const data = {
        ...form,
        id: dataToEdit.id,
        status_custom: form.status_custom ? 1 : 0
      };
      editData(data);
    } else {
      createData(form);
    }
  };

  const changeCheck = (e) => {
    handleInputChange(e);
    setCheck(e.target.checked);
  };

  const [handleDebounceRegexError] = useDebounceError();

  const handleRegex = ({ target }, type, regex) => {
    const { value } = target;
    handleDebounceRegexError(
      { target },
      handleInputChange,
      type !== 'all' ? `Este campo solo acepta ${type}` : `El carácter ${value[value.length - 1]} no es permitido en este campo`,
      regex
    );
  };

  return (
    <>
      <Text fontSize="md" my={4} style={{ fontWeight: 600 }}>
        {dataToEdit ? "Editar Aduanas" : "Crear Aduanas"}
      </Text>
      <Divider mb={3} />

      <form>
        <SimpleGrid minChildWidth="250px" spacing="20px">
          <div>
            <LabeFormlStyled htmlFor="code_custom">
              Correo electrónico
            </LabeFormlStyled>
            <InputFormStyled
              type="text"
              name="email_custom"
              id="email_custom"
              value={form?.email_custom}
              onChange={handleInputChange}
              maxLength={150}
            />
          </div>
          <div>
            <LabeFormlStyled htmlFor="code_custom">Código</LabeFormlStyled>
            <InputFormStyled
              name="code_custom"
              id="code_custom"
              value={form?.code_custom}
              onChange={(e) => handleRegex(e, 'Números', Regex?.numeros)}
              maxLength={150}
            />
          </div>
        </SimpleGrid>

        <SimpleGrid minChildWidth="250px" spacing="20px">
          <div>
            <LabeFormlStyled htmlFor="name_custom">
              Nombre Aduana
            </LabeFormlStyled>
            <InputFormStyled
              type="text"
              name="name_custom"
              id="name_custom"
              value={form?.name_custom}
              onChange={handleInputChange}
              maxLength={150}
            />
          </div>

          <div>
            <LabeFormlStyled htmlFor="description_custom">
              Descripción
            </LabeFormlStyled>
            <InputFormStyled
              type="text"
              name="description_custom"
              id="description_custom"
              value={form?.description_custom}
              onChange={handleInputChange}
              maxLength={5000}
            />
          </div>
        </SimpleGrid>

        {dataToEdit && (
          <div>
            <LabeFormlStyled htmlFor="status_custom">Activado</LabeFormlStyled>
            <div>
              <Switch
                name="status_custom"
                id="status_custom"
                size="lg"
                value={form?.status_custom}
                onChange={changeCheck}
                isChecked={check}
              />
            </div>
          </div>
        )}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap={"wrap"}
        >
          <ButtonStyled bgColor={"#bababa"} onClick={onCloseModal}>
            Cerrar
          </ButtonStyled>
          <ButtonStyled onClick={handleSubmit}>Aceptar</ButtonStyled>
        </Box>
      </form>
    </>
  );
};

export default CustomsForm;
